<template>
  <SalesDashboardCard title="Recent Reviews" class-card="col-12" :with-filters="false">
    <div slot="body">
      <Loader v-if="loading" />
      <div v-else class="d-flex flex-column">
        <div v-for="rating in ratings" :key="rating.id" class="rating-review" @click="openJob(rating)">
          <header class="rating-review-header">
            <div class="rating-review-info-wrapper">
              <h5 class="ref-id d-flex align-items-center">
                {{ rating.ref_id }}

                <span v-if="!rating.visible" title="Invisible review" class="mod-icon-alert-octagon ml-2" />
              </h5>
              <h6 class="company-name">{{ rating.company_name }}</h6>
            </div>

            <span class="rating-review-date">{{ rating.date }}</span>
          </header>
          <div class="rating-review-author-info">
            <h5 class="author-name">{{ rating.author.first_name }} {{ rating.author.last_name }}</h5>

            <div class="author-rating-wrapper">
              <span class="author-rating">{{ rating.rating }}</span>

              <star-rating
                :rating="rating.rating"
                :star-size="14"
                :show-rating="false"
                :increment="0.1"
                :read-only="true"
                style="max-height: 16px"
              />
            </div>
          </div>
          <p class="rating-review-body">
            {{ rating.body }}
          </p>
        </div>
      </div>
    </div>
  </SalesDashboardCard>
</template>

<script>
import axios from 'axios';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';

export default {
  components: { Loader, SalesDashboardCard },
  data() {
    return {
      ratings: [],
      loading: false,
    };
  },
  mounted() {
    this.getRatings();
  },
  methods: {
    getRatings() {
      this.loading = true;
      axios
        .get(`/sales/recent-ratings`)
        .then(res => {
          this.ratings = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openJob(rating) {
      window.open(`/jobs/edit/${rating.job_id}`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-review {
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 20px;
  padding-bottom: 10px;
  cursor: pointer;
}

.rating-review-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  .ref-id {
    text-transform: uppercase;
    color: #0f47e2;
    margin-bottom: 0 !important;
    line-height: 15px;
  }

  .company-name {
    color: black;
    font-size: 0.8rem;
    text-transform: uppercase;
  }

  .rating-review-date {
    font-size: 0.8rem;
    color: #8e8e92;
  }
}

.rating-review-author-info {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .author-name {
    color: black;
    font-size: 1rem;
  }

  .author-rating-wrapper {
    display: flex;
    align-items: center;

    .author-rating {
      font-size: 0.7rem;
      margin-right: 5px;
      margin-top: 5px;
    }
  }
}

.rating-review-body {
  word-wrap: break-word;
  font-size: 0.8rem;
  color: black;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/RecentReviews.vue